import { Injectable, InjectionToken } from '@angular/core';
import {
  OccPayment,
  OccPaymentsResponse,
  Payment,
  PaymentSystem,
  PaymentSystemImage,
  PaymentSystems,
  PaymentWays,
} from '@payment/const';
import { Converter } from '@spartacus/core';

/**
 * Будет поддержка только банковский карт.
 * Что еще прилетит в paymentWay, помимо CARD непонятно, но для банковских карт - это CARD.
 * Если вдруг нужны будут другие платежные способы, предварительно нужно настроить этот нормалайзер
 */
@Injectable()
export class OccPaymentsNormalizer implements Converter<OccPaymentsResponse, Payment[]> {
  convert(source: OccPaymentsResponse, target?: Payment[]): Payment[] {
    if (target === undefined) {
      target = [];
    }

    source.payments.forEach((occPayment) => {
      switch (occPayment.paymentWay) {
        case PaymentWays.Card:
          target.push(this.normalizeCard(occPayment));
          break;
        case PaymentWays.SbrfSbol:
          target.push(this.normalizeCard(occPayment));
          break;
        default:
          // Если что-то будет помимо карты
          break;
      }
    });

    return target;
  }

  private normalizeCard(occPayment: OccPayment): Payment {
    return {
      paymentWay: occPayment.paymentWay,
      bindingId: occPayment.bindingId,
      lastNumbers: occPayment.maskedPan.slice(-4),
      paymentSystemName: this.normalizePaymentSystemName(occPayment.paymentSystem),
      paymentSystemImage: this.normalizePaymentSystemImage(occPayment.paymentSystem),
    };
  }

  private normalizePaymentSystemName(paymentSystem: PaymentSystem): string {
    switch (paymentSystem) {
      case PaymentSystems.Visa:
        return 'Visa';
      case PaymentSystems.Mastercard:
        return 'Mastercard';
      case PaymentSystems.Mir:
        return 'Мир';
      default:
        return '';
    }
  }

  private normalizePaymentSystemImage(paymentSystem: PaymentSystem): PaymentSystemImage | null {
    switch (paymentSystem) {
      case PaymentSystems.Visa:
      case PaymentSystems.Mastercard:
      case PaymentSystems.Mir:
        return {
          src: `assets/images/payment-systems/${paymentSystem.toLowerCase()}.png`,
        };
      default:
        return {
          src: `assets/images/payment-systems/default.png`,
        };
    }
  }
}

export const PAYMENTS_NORMALIZER = new InjectionToken<OccPaymentsNormalizer>('PaymentsResponseNormalizer');
